// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1oyhD","image":"Header_image__26trc","name":"Header_name__2mZ6-","info":"Header_info__3rjnb","infoRow":"Header_infoRow__3VFQW"};